<template>
  <div class="c2-task-main" v-if="bodyShow">
    <h2>{{title}}</h2>
        <public-dialogue v-if="data.testid&&data.testid != 0" :testid="data.testid" :cid="$route.query.cid" :taskid="$route.query.id"></public-dialogue>
    <!--  -->
    <div v-for="(item,index) in list" :key="index">
      <!-- title -->
      <div v-if="item.type == 'title'" :class="['c2-task-group',item.sort==1?'on':'']" :style="item.config?h3Style(item.config):''">
        <!-- 处理字体颜色  -----参数:标题、需要变色的文字、颜色值、说明 -->
        <h3 v-html="doFontColor(item)"></h3>
      </div>
      <!-- text -->
      <div v-if="item.type=='text'" :class="['c2-task-group text',(item.type=='text' && item.label=='' )?'text_on':'']">
        <h3 v-if="item.label" v-html="doFontColor(item)"></h3>
        <div class="task-group-text">
          <textarea
            class="c2-textarea"
            @input="textareaChange(index,item)"
            v-model="item.content"
            :placeholder="item.config.placeholder"
          ></textarea>
          <span class="c2-word-limit">{{item.content?item.content.length:0}}/{{item.config.word}}</span>
        </div>
      </div>
      <!-- add -->
      <div v-if="item.type=='add'" class="c2-group">
          <!-- add -->
          <div v-if="action_array.length==0" class="add">
              <img  @click="addActionHandle(item)" src="@a/c2-add.png" alt="">
              <span v-if="action_array.length==0" class="small subtitle" v-html="doFontColor(item)"></span>
              <span v-else class="small subtitle" >添加喜欢的刊物/节目</span>
          </div>
          <!-- text -->
          <div v-else>
              <div v-for="(item2,index2) in action_array" :key="index2">
                  <div style="margin-top:15px;" class="c2-task-group text">
                      <h3  v-html="doFontColor(item2)"></h3>
                      <div class="task-group-text">
                          <textarea class="c2-textarea" @input="textareaChange(index2,item,'publication_array',index2,item2,0)" v-model="publication_array[index2]" :placeholder="isArray(0,item2.config.placeholder)" ></textarea>
                          <span class="c2-word-limit">{{publication_array[index2]?publication_array[index2].length:0}}/{{isArray(0,item2.config.word)}}</span>
                      </div>
                      <div class="task-group-text">
                          <textarea class="c2-textarea" @input="textareaChange(index2,item,'publication_array2',index2,item2,1)" v-model="publication_array2[index2]" :placeholder="isArray(1,item2.config.placeholder)" ></textarea>
                          <span class="c2-word-limit">{{publication_array2[index2]?publication_array2[index2].length:0}}/{{isArray(1,item2.config.word)}}</span>
                      </div>
                  </div>
                  <!--  -->
                  <div class="c2-group" >
                      <!-- add -->
                      <div v-if="action_array.length<action_item.config.num" class="add">
                          <img  @click="addActionHandle(action_item)" src="@a/c2-add.png" alt="">
                          <span v-if="action_array.length==0" class="small subtitle" v-html="doFontColor(item2)"></span>
                          <span v-else class="small subtitle" >添加喜欢的刊物/节目</span>
                      </div>
                      <!--  -->
                      <div  class="add">
                          <img @click="doRemoveHandle(index2)" src="@a/c2-remove.png" alt="">
                          <span class="small subtitle">删除喜欢的刊物/节目</span>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <!-- subtitle -->
      <div v-if="item.type=='subtitle'" class="c2-task-group subtitle">
        <small class="small subtitle" v-html="doFontColor(item)"></small>
      </div>
      <!-- textarea -->
      <div
        v-if="item.type == 'textarea'"
        :class="['c2-task-group',(item.type == 'textarea' && item.label=='')?'textarea_on':'textarea_mt']"
      >
        <h3 v-if="item.label" v-html="doFontColor(item)"></h3>
        <div class="task-group-text">
          <textarea
            class="c2-textarea"
            @input="textareaChange(index,item)"
            v-model="item.content"
            :placeholder="item.config.placeholder"
          ></textarea>
          <span class="c2-word-limit">{{item.content?item.content.length:0}}/{{item.config.word}}</span>
        </div>
      </div>
    </div>
    <!-- 引入项目攻略入口 -->
    <task-strategy :cid="$route.query.cid" :pid="$route.query.pid"></task-strategy>
    <!-- submit -->
    <button :class="['c-submit',bool?'on':'']" @click="submithandle">提交</button>
    <!-- 删除弹窗 -->
    <van-popup class="pub_alert" v-model="deletePopup">
        <div class="confirm_box">
            <h2>是否确认删除？</h2>
            <div class="btn_group">
                <a class="confirm on" href="javascript:;" @click="removeActionHandle">确认</a>
                <a class="cancel" href="javascript:;" @click="deletePopup=false">取消</a>
            </div>
        </div>
    </van-popup>
  </div>
</template>

<script>
import { index, subtable } from "@/api/course";
import { getStorage, setStorage,deepCopy } from "@/utils/tools";
import { shareCon } from "@/utils/wxconfig";
import TaskStrategy from "@c/course/task-strategy"
export default {
  data() {
    return {
      bodyShow: false,
      title: "",
      list: [],
      userfield: [],
      bool: true,
      word_num: 0,
      action_array:[],
      // 从第几个开始
      begin_num:0,
      // 存储需要添加类型
      action_item:{},
      deletePopup:false,
      action_index:null,
      // 喜欢的刊物Array
      publication_array:[],
      publication_array2:[],
      data:{},
    };
  },
  components:{
    TaskStrategy
  },
  computed:{
    /*
     *@param:
     *@return:
     *@Description: 标题样式
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-10-30 12:06:12
    */
    h3Style(){
      return function(config) {
        return (config.typeSet && config.typeSet.top)?`margin-top:${config.typeSet.top/2}px;`:''
      }
    },
    /*
     *@param:
     *@return:
     *@Description: 判断是否是数组
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-10-30 12:05:46
    */
    isArray(){
      return function(num,arr){
        if(arr instanceof Array){
          return arr[num]
        }else{
          return arr
        }

      }
    },
    /*
     *@param:
     *@return:
     *@Description: 处理喜欢的刊物数组
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-10-30 10:56:30
    */
    actionArray(){
      return function (arr){
        let bool = false;
        arr.forEach((item,index)=>{
          if(!item){
            return bool= true;
          }
        });
        return bool;
      }
    }

  },
  methods: {
    doRemoveHandle(index){
      this.deletePopup = true;
      this.action_index = index;
    },
    // 删除喜欢的刊物/节目
    removeActionHandle(){
      // 删除数组内的值
      this.$delete(this.action_array,this.action_index);
      this.$delete(this.publication_array,this.action_index);
      this.$delete(this.publication_array2,this.action_index);
      // 获得缓存,删除已选择刊物数组下标元素，重新赋值缓存
      let storage = getStorage(this.$route.path, 'publication_array');
      this.$delete(storage,this.action_index);
      setStorage(this.$route.path, 'publication_array', storage);
      this.begin_num-=1;
      let num = this.begin_num<6?this.begin_num-1:this.begin_num-2;
      for(let i = this.action_index;i<this.action_array.length;i++){
          this.action_array[i].config.typeSet.text = this.action_array[i].config.typeSet.text.split(/[0-9]+/)[0]+(num+i);
          this.action_array[i].label = this.action_array[i].label.split(/[0-9]+/)[0]+(num+i);
      }

      this.deletePopup = false;
      // 调用验证方法
      this.validationHandle();
    },
    /*
      *@param:
      *@return: bl 初始化判断参数
      *@Description: 添加行动
      *@MethodAuthor:  Zhang Xiao Guang
      *@Date: 2019-10-16 18:30:31
    */
    addActionHandle(item,bl){
        if(Object.keys(item).length>0){
            this.action_item = {...item};
        }
        if(this.begin_num==0){
            this.begin_num = item.config.startnum;
        }
        if(this.action_array.length<=item.config.num){
          for(let i=0;i<this.list.length;i++){
              // 正则去数字之前的标题
              if((this.list[i].type=='add' ||this.list[i].type=='text' || this.list[i].type=='textarea') && item.config.title && this.list[i].label.indexOf(item.config.title.text.split(/[0-9]+/)[0])>-1){
                let obj = deepCopy(this.list[i]);
                obj.sort = item.sort+=1;
                // 因为缓存里边没有title对象值所以初始化需要通过label来处理
                obj.label = item.config.title.text.split(/[0-9]+/)[0]+this.begin_num;
                obj.id = item.id;
                obj.content= bl?[item.content['content1']||'',item.content['content2']||'']:[];
                obj.config.placeholder=item.config.placeholder;
                // 加上从第几个开始，统一改变字体颜色
                let typeSet_ = deepCopy(item.config.title.typeSet);
                typeSet_.text+=this.begin_num;
                obj.config.typeSet = deepCopy(typeSet_);
                obj.config.word = item.config.word;
                this.action_array.push(obj);
                // 喜欢的刊物Array
                this.publication_array.push(obj.content[0]?obj.content[0]:'');
                this.publication_array2.push(obj.content[1]?obj.content[1]:'');
                if(this.begin_num<=6){
                    this.begin_num+=1;
                }
                // 调用验证方法
                this.validationHandle();
                break;
            }
          }
        }
    },
    // 改变字体颜色
    doFontColor(item){
        let font = item.label;
        let typeSet = item.config.typeSet?item.config.typeSet:'';
        let subtitle = item.config.subtitle?item.config.subtitle:'';
        // small是括号里的说明
        if(typeSet instanceof Array){
          typeSet.forEach((item,idx)=>{
              font = font.replace(item.text,(v)=>{
                  return v.fontcolor(item.color)
              })+((subtitle && subtitle.position!='bottom')?"<span class='small'>"+subtitle.text+"</span>":'');
          });
            return font;
        }else if(typeSet.text instanceof Array) {
            typeSet.text.forEach((item,idx)=>{
                font = font.replace(item,(v)=>{
                    return v.fontcolor(typeSet.color)
                })+((subtitle && subtitle.position!='bottom')?"<span class='small'>"+subtitle.text+"</span>":'');
            });
            return font;
        } else {
            return font.replace(typeSet.text,(v)=>{
                return v.fontcolor(typeSet.color)
            })+((subtitle && subtitle.position!='bottom')?"<span class='small'>"+subtitle.text+"</span>":'');
        }
    },
    /*
      *@param: index 下标、item 改变值的对象、type 类型、num 动态添加兴趣的第几个、actionitem 动态改变添加兴趣值的对象
      *@return:
      *@Description: 改变输入框时触发
      *@MethodAuthor:  Zhang Xiao Guang
      *@Date: 2019-10-17 10:59:14
    */
    textareaChange(index,item,type,num,item2,wordNum){
        this.$forceUpdate();
        // 判断是否是添加兴趣刊物
        if(type && (type==='publication_array'||type==='publication_array2')){
          let t = type;
          item2['content'][wordNum]= this[t][num];
          // 复制对象
          let actionitem = deepCopy(item2);
          if(actionitem.content[wordNum] && actionitem.content[wordNum].length > item.config.word[wordNum]) {
            this.$set(this[t],num,actionitem.content[wordNum].slice(0, item.config.word[wordNum]));
            this.$toast(`最多只能输入${item.config.word[wordNum]}个字。/(ㄒoㄒ)/~~`);
          }else{
            let arr = deepCopy(actionitem);
            let storage = getStorage(this.$route.path, 'publication_array');
            this.$delete(arr,'config');
            this.$set(arr, 'config',item.config)
            let list = storage?storage:[];
            this.$set(list,num,arr);
            setStorage(this.$route.path, 'publication_array', list);
          }
        }else{
            if(item.content && item.content.length > item.config.word) {
              this.$set(this.list[index],'content',item.content.slice(0, item.config.word));
              this.$toast(`最多只能输入${item.config.word}个字。/(ㄒoㄒ)/~~`);
            }else{
              setStorage(this.$route.path, 'id'+item.id, item.content);
            }
        }
        this.validationHandle();
    },
    pullData() {
      // loading
      this.$toast.loading({
        mask: true,
        message: "加载中..."
      });
      // 获取页面初始化数据
      index({
        cid: this.$route.query.cid,
        cpid: this.$route.query.pid,
        cptid: this.$route.query.id
      }).then(data => {
        this.$toast.clear();
        if (data.code === 10002) {
          this.$toast(data.data.msg);
          return;
        }
        this.list = data.field;
        this.userfield = data.userfield;
        document.title = this.$route.query.name;
        this.title = data.title;
        this.data = data;
        this.validationHandle(true);
        this.bodyShow = true;
      });
    },
    validationHandle(bl) {
      let b = true;
      if (this.list && this.list.length == 0) {
        this.bool = false;
        return;
      }
      this.list.forEach((item, index) => {
        // 判断是否是初始化
        if (bl) {
          // 判断是否已提交过数据
          if(this.userfield && this.userfield.length > 0) {
            this.userfield.forEach((item2, key) => {

              if (item2.content && item2.field_id == item.id) {
                if(item.type=='add' && (item2.content.startsWith('{') || item2.content.startsWith('['))){
                  JSON.parse(item2.content).forEach((item3,index)=>{
                    let obj_ = {...item};
                    obj_['content'] = item3;
                    this.addActionHandle(obj_,bl);
                  });
                }else{
                  this.list[index].content = item2.content;
                }
              }
            });
          } else {
            if(item.type=='add'){
              // 判断是否是动态添加的兴趣刊物
              if(getStorage(this.$route.path, 'publication_array')){
                let storage = deepCopy(getStorage(this.$route.path, 'publication_array'));
                storage.forEach((item,index2)=>{
                  let obj_ = {...this.list[index]};
                  obj_['content'] = {
                    content1:item.content[0],
                    content2:item.content[1]
                  };
                  // 处理content数据格式
                  this.addActionHandle(obj_,bl);
                });
              }
            }

            this.list[index].content = this.list[index].content
              ? this.list[index].content
              : getStorage(this.$route.path, "id" + item.id) || "";
          }
        }
        // 判读是否有空
        if (
          (this.list[index].type == "text" ||
            this.list[index].type == "textarea") &&
          (!this.list[index].content || this.list[index].content == "")
        ) {
          b = false;
        }
      });
      // 判断新增的是否有空
      this.action_array.forEach((item,index)=>{
          // 判读是否有空
          if((this.action_array[index].type=='text' || this.action_array[index].type=='textarea') && (this.actionArray(this.action_array[index].content)||this.action_array[index].content.length==0)){
            return  b =false;
          }
      });
      this.bool = b;
    },
    submithandle() {
      if (this.bool) {
        let arr = [];
        this.list.forEach((item, index) => {
          if (item.content) {
            arr.push({
              field_id: item.id,
              content: item.content
            });
          }
        });
        if(this.action_array.length>0){
          let content = [],ids=null;
          this.action_array.forEach((item2,index)=>{
              ids = item2.id;
              content.push({
                content1:item2.content[0],
                content2:item2.content[1]
              });
          });
          arr.push({
              field_id:ids,
              content:JSON.stringify(content)
          });
        }
        // return false;
        subtable({
          cid: this.$route.query.cid,
          form_id: this.list[0].form_id, //引入form_id都是一样的，所以取一个就可以
          field: JSON.stringify(arr)
        }).then(data => {
          this.$toast({
            duration: 1000,
            message: "提交成功！",
            onClose: () => {
              this.$router.push({
                path: "/project_report",
                query:{
                                    cid:this.$route.query.cid,
                                    cpid:this.$route.query.pid,
                                    taskid: this.$route.query.id
                                }
              });
            }
          });
        });
      }
    }
  },
  created() {
    this.pullData();
    shareCon("course2", this);
  }
};
</script>

<style lang="scss" scope>
.c2-task-main {
  padding: 40px 30px 80px;
  text-align: center;
  background-color: #f0f0f0;
  h2 {
    font-weight: bold;
    font-size: 36px;
    color: #333333;
    text-align: center;
  }
  .c2-task-group {
    margin-top: 30px;
    position: relative;
    text-align: left;
    line-height: 1;
    .task-group-text {
      position: relative;
    }
    h3 {
      text-align: left;
      font-size: 32px;
      color: #333333;
      line-height: 1;
    }
    .c2-textarea {
      height: 160px;
      border-radius: 8px;
      background-color: #fff;
      border: 0;
      width: 100%;
      padding: 22px 20px;
      font-size: 26px;
      resize: none;
      text-align: left;
    }
    .c2-word-limit {
      position: absolute;
      font-size: 18px;
      color: #999;
      bottom: 14px;
      right: 16px;
    }
    .small {
      font-size: 24px;
      // color: #666666;
      line-height: 36px;
      span {
        // color: #ea345c;
        margin-right: 5px;
      }
    }
  }
  .c2-task-group.-mt {
    margin-top: 50px;
  }
  .c2-task-group.on{
    margin-top: 40px;
  }
  .c2-task-group.subtitle {
    margin-top: 10px;
  }
  .c2-task-group.textarea_on{
    margin-top: 14px;
    line-height: 1;
  }
  .c2-task-group.textarea_mt{
    h3{
      line-height: 42px;
    }
    textarea{
      margin-top: 14px;
    }
  }
  .c2-task-group.text {
    margin-top: 14px;
    h3 {
      color: #333333;
      line-height: 1;
    }
    .task-group-text {
      position: relative;
    }
    .c2-textarea {
      margin-top: 14px;
      height: 70px;
      line-height: 70px;
      padding: 0px 20px;
    }
    .c2-radio-group {
      margin-top: 14px;
      font-size: 0;
      .van-radio__icon {
        display: none;
      }
      .van-radio__label {
        text-align: center;
        vertical-align: unset;
        line-height: 70px;
        margin-left: auto;
        color: #ea345c;
        width: 100%;
      }
      .radio-btn {
        padding: 0;
        width: 156px;
        height: 70px;
        line-height: 70px;
        font-size: 26px;
        border: 2px solid #ea345c;
        border-radius: 8px;
        color: #ea345c;
        margin-right: 20px;
        display: inline-block;
        background-color: #fff;
      }
      .radio-btn.active .van-radio__label {
        background-color: #ea345c;
        color: #fff;
      }
      .radio-btn:last-child {
        margin-right: 0px;
      }
    }
  }
  .c2-task-group.text.text_on {
    line-height: 1;
    .c2-textarea {
      margin-top: 0px;
      height: 70px;
      line-height: 70px;
      padding: 0px 20px;
    }
  }
  .c2-task-group.holland {
    margin-top: 28px;
    h3 {
      font-size: 28px;
      color: #333333;
      line-height: 1;
    }
  }
  .c-submit {
    width: 174px;
    height: 66px;
    background: #cccccc;
    border-radius: 33px;
    font-size: 34px;
    color: #ffffff;
    border: 0;
    margin: 80px auto auto;
  }
  .c-submit.on {
    background-color: #ea345c;
  }
  /* 弹窗 */
  .explain {
    width: 690px;
    padding: 40px 50px;
    border-radius: 9px;
    text-align: left;
    h2 {
      text-align: left;
      margin-top: 0;
      font-size: 32px;
      color: #ea345c;
      font-weight: normal;
      margin-bottom: 24px;
    }
    .pps {
      font-size: 26px;
      line-height: 48px;
      color: #333;
      text-align: justify;
    }
  }
  .c2-group{
    font-size: 0;
    text-align: left;
    .add{
        margin-top: 10px;
        margin-right: 40px;
        display: inline-block;
        img{
            width: 36px;
            height: 36px;
            margin-right: 10px;
            vertical-align: top;
        }
        .small{
            font-size:24px;
            color: #666666;
            span{
                // color: #EA345C;
                margin-right: 5px;
            }
        }
    }
  }
}
</style>